import '../../Portale.css'; // Importa il file CSS per lo stile

import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-modal';
import { IoClose, IoCloseCircleSharp, IoAddCircleSharp } from "react-icons/io5";
import { PortaleContext } from '../../store/portale-context';
import { Button } from 'react-bootstrap';
import RicorrenzeTable from '../tables/RicorrenzeTable';
import { ColumnFilter } from '../ColumnFilter';

function ModalGestioneRicorrenze({ chiudiModalRicorrenze, visible, disattivaRicorrenza }) {

    const portaleCtx = useContext(PortaleContext);   

    const columns = [
        { Header: 'Data Inizio', accessor: 'DataInizio', Filter: ColumnFilter },
        { Header: 'Ricorrenza', accessor: 'TipoRicorrenza', Filter: ColumnFilter },
        { Header: 'Destinatari', accessor: 'NomiDestinatari', Filter: ColumnFilter },
        { Header: 'Cliente', accessor: 'Cliente', Filter: ColumnFilter },
        { Header: 'Commessa', accessor: 'Commessa', Filter: ColumnFilter },
        { Header: 'Tipo Richiesta', accessor: 'TipoRichiesta', Filter: ColumnFilter },
        { Header: 'Messaggio Iniziale', accessor: 'MessaggioIniziale', Filter: ColumnFilter },
    ];

    return (
        <Modal
            isOpen={visible}
            onRequestClose={() => chiudiModalRicorrenze()}
            className="info-modal-chat"
            contentLabel="Example Modal"
            ariaHideApp={false}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // Cambia l'opacità per aumentare l'oscuramento
                    zIndex: 10,
                },
                content: {
                    zIndex: 11,
                },
            }}
        >
            <div>
                <IoClose
                    className="close-icon"
                    onClick={() => chiudiModalRicorrenze()}
                />
            </div>

            <h3 className="info-modal-title" style={{ marginTop: '0px', marginBottom: '15px' }}>
                Gestione ricorrenze
            </h3>

            <div className='contact-form'>

                {portaleCtx.attivitaRicorrenti != undefined ?
                    <RicorrenzeTable columns={columns} data={portaleCtx.attivitaRicorrenti} disattivaRicorrenza={disattivaRicorrenza} />
                    : <></>}
                <div className="buttons" style={{ width: '90%', dislay: 'flex', justifyContent: 'center' }}>
                    <Button
                        className="button red"
                        onClick={() => chiudiModalRicorrenze()}>
                        Chiudi <IoCloseCircleSharp className="text-icon-right" />
                    </Button>
                </div>
            </div>

        </Modal>
    );
}

export default ModalGestioneRicorrenze;